import React from "react";
import { useAuth } from "../contexts/AuthContext";
import NotFound from "./NotFound";

const SuperAdminRoute = ({ children }) => {
  const { isSuperAdmin, isAuthenticated } = useAuth();

  // If not authenticated, show 404 (don't reveal that the route exists)
  if (!isAuthenticated) {
    return <NotFound />;
  }

  // If authenticated but not super_admin, show 404
  if (!isSuperAdmin()) {
    return <NotFound />;
  }

  // If super_admin, render the protected component
  return children;
};

export default SuperAdminRoute;
